

/* eslint-disable */

import { defineComponent } from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import {
  exampleTournament, Position, Tournament
} from '@/views/interfaces/entities.ts';
import TournamentBrackets from './Main/TournamentBrackets.vue';
import MatchCard from './WatchTournament/MatchCard.vue';

export default defineComponent({
  name: 'tournament-main',
  components: {
    MatchCard,
    TournamentBrackets,
  },
  data() {
    return {
      tournament: exampleTournament as Tournament,
    };
  },
  computed: {
    ...mapGetters({
      getTournament: 'tournament/getTournament',
    }),
  },
  mounted() {
    this.setTournament(this.tournament);
    this.mockLiveVoting();
    this.mockLiveVoting();
  },
  methods: {
    ...mapMutations({
      setTournament: 'tournament/SET_TOURNAMENT',
    }),
    getRandomElements(arr: any[], n: number) {
      let result = new Array(n),
        len = arr.length,
        taken = new Array(len);
      if (n > len) throw new RangeError('getRandom: more elements taken than available');
      while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
      }
      return result;
    },
    mockLiveVoting(){
      const myInterval = setInterval( () => {
        const index = this.getRandomElements([3,14,15,16], 1)[0];
        const pos = this.getTournament.positions.find((position: Position) => position.id === index);
        pos.votes += 1;
      }, 1700);
      setTimeout(() => clearInterval(myInterval), 90000);
    }
  },


});
